import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import "./Header.css";
import logo from "../../assets/image/1-02.png";
// import logo from "../../assets/image/Artboard 1 (2).png";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const toggleNavbar = () => setIsOpen(!isOpen);
  const closeNavbar = () => setIsOpen(false);
  const location = useLocation();
  const navItems = [
    { to: "/", label: "الرئيسية" },
    { to: "/about", label: "من نحن" },
    // { to: "/destinations", label: "الوجهات السياحية" },
    // { to: "/magazine", label: "مجلة سياحية" },
    { to: "/contact", label: "تواصل معنا" },
  ];

  return (
    <nav className="navbar navbar-expand-lg bg-white shadow-sm sticky-top py-2 header-navbar">
      <div className="container-fluid d-flex align-items-center justify-content-between flex-wrap">
        {/* الشعار */}
        <Link className="navbar-brand" to="/" onClick={closeNavbar}>
          <img src={logo} alt="Logo" height="50"/>
        </Link>

        {/* زر الهامبرجر */}
        <button
          className={`menu-btn ${isOpen ? "open" : ""}`}
          onClick={toggleNavbar}
          aria-label="Toggle menu"
        >
          <div className="menu-icon">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>

        {/* روابط + زر */}
        <div
          className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}
          id="navbarNav"
        >
          <div className="flex-grow-1 d-flex flex-column flex-lg-row align-items-center justify-content-between gap-3">
            {/* روابط التنقل */}
            <div className="nav-center mx-auto">
              <Nav
                variant="tabs"
                defaultActiveKey={location.pathname}
                className="custom-nav d-flex flex-column flex-lg-row align-items-center gap-3"
                onSelect={closeNavbar}
              >
                {navItems.map(({ to, label }) => (
                  <Nav.Item key={to}>
                    <Nav.Link
                      as={Link}
                      to={to}
                      eventKey={to}
                      className={`fw-semibold nav-link-custom ${
                        location.pathname === to ? "active-nav" : ""
                      }`}
                    >
                      {label}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </div>

            {/* زر طلب الخدمة */}
            <div className="service-button">
              <Link
                to="/contact"
                className="btn btn-danger px-4 py-2 fw-bold rounded-3"
                onClick={closeNavbar}
              >
                طلب الخدمة
              </Link>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
